<footer class="footer">
    <p class="copyright">
        © {{year}} <span><a target="_blank" href="https://inndeve.com/">Inndeve,</a></span> All Rights Reserved
    </p>
   
</footer>